<template>
    <tg-layout prefixCls="reward-record" :headerHeight="headerHeight">
        <portal to="title">{{ $route.meta }}</portal>
        <template slot="header">
            <tg-search-tool
                :data="searchData"
                @on-submit="handleSearch"
                :styleObj="{ 'margin-left': '.3em', padding: '0 20px' }"
            >
                <tg-date-search
                    ref="dateSearch"
                    size="small"
                    v-model="dateRange"
                    showDateRangePicker
                    twoMonthLimit
                    isAccountDate
                ></tg-date-search>
                <el-input
                    :placeholder="$t('component.form.input.placeholder.game')"
                    v-model="searchData.targetName"
                    class="tg-input"
                    size="small"
                    style="width: 240px"
                    clearable
                ></el-input>
            </tg-search-tool>
            <tg-amount-bar
                v-if="showAmount"
                :columns="amountColumns"
                :row="amount"
            ></tg-amount-bar>
        </template>
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            showPagination
            @on-loaded="handleLoaded"
        >
            <template slot="game_name" slot-scope="scope">
                <span>[{{ scope.row["competition"] }}]</span><br />
                <span
                    ><i class="tg-icon tg-icon-grayball"></i
                    >{{ scope.row["team1"] }}</span
                ><br />
                <span
                    ><i class="tg-icon tg-icon-grayball"></i
                    >{{ scope.row["team2"] }}</span
                ><br />
            </template>
            <template slot="link" slot-scope="scope">
                <a
                    v-if="scope.value > 0"
                    @click.prevent="handleLink(scope)"
                    href
                    >{{ scope.formated }}</a
                >
                <span v-else>{{ scope.formated }}</span>
            </template>
        </tg-table>
    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgAmountBar from "@/components/amount/TgAmountBar";

import apis from "@/apis";
// import mockRecord from "@/mock/tg_business/reward/record";
// import { Loading } from "element-ui";
// import date from "@/utils/date";
const api = apis.tg_business.reward.record;

export default {
    components: {
        TgLayout,
        TgSearchTool,
        TgDateSearch,
        TgAmountBar,
    },
    data() {
        return {
            columns: [],
            amountColumns: [],
            amount: {},
            proxy: api.getData,
            searchData: {},
            dateRange: {},
            showAmount: false,
        };
    },
    // beforeCreate() {
    //     if (process.env.NODE_ENV !== "production") {
    //         let loadingInstance = Loading.service({ fullscreen: true });
    //         mockRecord.mock();
    //         this.$nextTick(() => {
    //             // 以服务的方式调用的 Loading 需要异步关闭
    //             loadingInstance.close();
    //         });
    //     }
    // },
    created() {
        this.$store.commit("breadcrumb/clear");
        let request = this.request;

        // 檢查歷史查詢戳記
        if (this.historyKey) {
            if (!this.$history.exist(this.historyKey)) {
                this.$router.push({ name: this.$route.name });
                return;
            }
            // 將請求參數自歷史取出
            request = this.$history.get(this.historyKey);

            // 需要使用nextTick 不然會被dateSearch元件的mounted蓋掉值
            this.$nextTick(() => {
                this.searchData = { ...request };
                this.dateRange = {
                    startDate: request.startDate,
                    endDate: request.endDate,
                };
            });
        }
    },
    mounted() {
        // 優化，當網址列有其他參數格式存在，在使用者按下F5時
        // 會導致history相關程式碼無法正確往下執行，導致columns為空
        // 故將getColumns改放在mounted
        api.getColumns({ project: "index" }).then((response) => {
            this.columns = response.data.tableColumns;
            this.amountColumns = response.data.amountColumns;
            this.$refs.table.init(this.request);
        });
    },
    computed: {
        storeCache() {
            return this.$store.state.breadcrumb.caches[this.$route.name];
        },
        request() {
            return Object.assign({}, this.searchData, this.dateRange);
        },
        parseMaxHeight() {
            return window.innerHeight - 370;
        },
        headerHeight() {
            return this.showAmount ? 140 : 80;
        },
    },
    methods: {
        handleSearch() {
            let historyKey = this.$history.add(this.request);
            this.$router.push({
                name: this.$route.name,
                query: { h: historyKey },
            });
        },
        handleLoaded(response) {
            if(response.retcode == 0){
                this.amount = response.total;
                this.showAmount = this.amount && response.data.length > 0;
            }
        },
        handleLink(scope) {
            let keyData = {
                event: scope.row["event"],
                game_time: scope.row["origin_game_time"] ? scope.row["origin_game_time"] : scope.row["game_time"],
            };

            let params = {
                ...keyData,
                game_name: scope.row["game_name"],
                title: scope.column.title,
                reward: scope.column.reward,
            };

            let historyKey = this.$history.add(params, keyData);

            this.$router.push(
                {
                    name: "tg_business.reward-record.member",
                    query: { h: historyKey },
                },
                () => {},
                () => {}
            );
        },
    },
    watch: {
        $route(value) {
            if (this.$history.exist(value.query.h)) {
                this.searchData = this.$history.get(value.query.h);
            } else {
                this.$refs.dateSearch.select("today");
            }
            this.$nextTick(() => {
                this.$refs.table.search(this.request);
            });
        },
        searchData(val) {
            if (val.startDate) {
                this.dateRange.startDate = val.startDate;
            }

            if (val.endDate) {
                this.dateRange.endDate = val.endDate;
            }
        },
        showAmount() {
            this.$nextTick(() => {
                this.$refs.table.doLayout();
            });
        },
    },
};
</script>
